import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { t } from '@nextcloud/l10n'
import { NcActionButton, NcActions } from '@nextcloud/vue'
import { useHotKey } from '@nextcloud/vue/composables/useHotKey'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ViewComfy from 'vue-material-design-icons/ViewComfy.vue'
import ViewDay from 'vue-material-design-icons/ViewDay.vue'
import ViewGrid from 'vue-material-design-icons/ViewGrid.vue'
import ViewList from 'vue-material-design-icons/ViewList.vue'
import ViewModule from 'vue-material-design-icons/ViewModule.vue'
import ViewWeek from 'vue-material-design-icons/ViewWeek.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavigationHeaderViewMenu',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const views = [{
	id: 'timeGridDay',
	icon: ViewDay,
	label: t('calendar', 'Day'),
}, {
	id: 'timeGridWeek',
	icon: ViewWeek,
	label: t('calendar', 'Week'),
}, {
	id: 'dayGridMonth',
	icon: ViewModule,
	label: t('calendar', 'Month'),
}, {
	id: 'multiMonthYear',
	icon: ViewComfy,
	label: t('calendar', 'Year'),
}, {
	id: 'listMonth',
	icon: ViewList,
	label: t('calendar', 'List'),
}]

const defaultIcon = computed(() => {
	for (const view of views) {
		if (view.id === route.params.view) {
			return view.icon
		}
	}

	return ViewGrid
})

async function selectView(viewName: string): Promise<void> {
	// Don't push new route when view didn't change
	if (route.params.view === viewName) {
		return
	}

	const name = route.name!
	const params = {
		...route.params,
		view: viewName,
	}

	await router.push({ name, params })
}

useHotKey(['d', '1'], () => selectView('timeGridDay'))
useHotKey(['w', '2'], () => selectView('timeGridWeek'))
useHotKey(['m', '3'], () => selectView('dayGridMonth'))
useHotKey(['y', '4'], () => selectView('multiMonthYear'))
useHotKey(['l', '5'], () => selectView('listMonth'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(NcActions), { menuAlign: "right" }, {
      icon: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(defaultIcon.value), { size: 20 }))
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(views, (view) => {
          return _createVNode(_unref(NcActionButton), {
            key: view.id,
            icon: view.icon,
            closeAfterClick: true,
            onClick: ($event: any) => (selectView(view.id))
          }, {
            icon: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(view.icon), { size: 20 }))
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(view.label), 1)
            ]),
            _: 2
          }, 1032, ["icon", "onClick"])
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})